import { ArnValidNftConfig, UrlUtil } from '@arianee/arn-types';
import { ArnNftConfig, ArnNftConfigImpl } from './ArnNftConfig';
import { HttpNftService } from './HttpNftService';
import { ArnHttpService } from '../http';
import { ArnAuthService } from '../auth';
import { ArnNftServiceFactory } from './ArnNftServiceFactory';
import { ArnNftService } from './ArnNftService';
import { ArnLogger } from '../log';

export class HttpNftServiceFactory implements ArnNftServiceFactory {
  createConfig(spec?: ArnNftConfig, baseUrl?: string): ArnValidNftConfig {
    return new ArnNftConfigImpl(
      {
        url: UrlUtil.build(spec?.list?.url, 'nft/list/', baseUrl),
      },
      {
        ipfs: {
          baseUrls: [
            'https://dweb.link/ipfs/',
            'https://ipfs.io/ipfs/',
            'https://gateway.pinata.cloud/ipfs/',
            'https://ipfs.nftstorage.link/ipfs/',
          ],
          retry: {
            failure: {
              waitDuration: 2000,
              retryCount: 0,
            },
          },
        },
      }
    );
  }

  create(
    log: ArnLogger,
    http: ArnHttpService,
    auth: ArnAuthService,
    baseUrl?: string,
    spec?: ArnNftConfig
  ): ArnNftService {
    const config = this.createConfig(spec, baseUrl);
    return new HttpNftService(log, http, auth, config);
  }
}
